import { render } from "./ShipmentsByCourier.vue?vue&type=template&id=51f3dd15&scoped=true"
import script from "./ShipmentsByCourier.vue?vue&type=script&lang=js"
export * from "./ShipmentsByCourier.vue?vue&type=script&lang=js"

import "./ShipmentsByCourier.vue?vue&type=style&index=0&id=51f3dd15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f3dd15"]])

export default __exports__